import { useTranslation } from 'react-i18next'
import Input from "components/common/Input/Input"
import InputError from "components/common/InputError/InputError"

const Turnover = ({ register, error, value }) => {
  const { t } = useTranslation()

  return (
    <>
      <Input
        error={error}
        register={register('turnover', {
          required: t('mainReporting:form.mandatory'),
          validate: value => /^\d+$/.test(value?.replace(/ /g, '')) || t('mainReporting:form.turnover.errors.pattern')
        })}
        label={t('mainReporting:form.turnover.label')}
        placeholder={t('mainReporting:form.turnover.placeholder')}
        disallowLetters={true}
        value={value?.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}
      />
      <InputError error={error} />
    </>
  )
}

export default Turnover
